import React from "react";

const Spinner = () => (
  <>
    {/* Bokeh backdrop */}
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9998,
        backdropFilter: "blur(5px) brightness(0.88)",
        WebkitBackdropFilter: "blur(5px) brightness(0.88)",
        background: "radial-gradient(ellipse at center, rgba(0,0,0,0.04) 0%, rgba(0,0,0,0.16) 100%)",
        cursor: "wait",
        animation: "fadeIn 0.25s ease forwards",
      }}
    />

    {/* Centered card - using flexbox for perfect centering */}
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
      }}
    >
      <div
        role="status"
        aria-label="Loading"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          padding: "32px 44px",
          borderRadius: 22,
          background: "var(--glass-bg)",
          border: "1px solid rgba(99,102,241,0.18)",
          boxShadow: "0 24px 64px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06)",
          animation: "scaleIn 0.3s cubic-bezier(0.34,1.56,0.64,1) forwards",
        }}
      >
        {/* Smooth dot-wave — opacity + scale only = buttery smooth */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {[
            { color: "#6366f1", delay: "0s" },
            { color: "#8b5cf6", delay: "0.15s" },
            { color: "#06b6d4", delay: "0.3s" },
          ].map(({ color, delay }, i) => (
            <div
              key={i}
              aria-hidden="true"
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: color,
                boxShadow: `0 0 8px ${color}99`,
                animation: `dotWave 1.2s ease-in-out ${delay} infinite`,
                willChange: "transform, opacity",
              }}
            />
          ))}
        </div>

        <span style={{
          fontSize: "0.8125rem",
          fontWeight: 600,
          color: "var(--text-muted)",
          letterSpacing: "0.05em",
          textTransform: "uppercase",
        }}>
          Loading
        </span>

        {/* Keyframes scoped here so they don't pollute global */}
        <style>{`
          @keyframes dotWave {
            0%, 60%, 100% { transform: translateY(0) scale(1);   opacity: 0.45; }
            30%            { transform: translateY(-9px) scale(1.15); opacity: 1;    }
          }
        `}</style>
      </div>
    </div>
  </>
);

export default Spinner;
